import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, useMediaQuery } from "../../../Styles";
import { DataObj, labelToKeyMap, Params, ReportData, ReportTemplate } from "../../../Definitions/valueTypes";

// TODO
// import { ReportTemplate } from "../../../Assets/TestData/reportTemplates";
import CheckBox, { CheckStyles } from "../../BaseComponents/checkBox";

interface Lvl3_Props {
  templateData?: ReportTemplate
  onTemplateDataChange: (data: ReportTemplate) => void
}

export default function TemplateModalLvl3({ templateData, onTemplateDataChange }: Lvl3_Props) {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  const checkboxes = useMemo(() => {
    const dataParameters: Params[] = [
      // "locationId", 
      "animalGroupId", 
      // "conditionId", 
      // "attentionId", 
      "milestoneId"
    ] as Params[];

    return dataParameters.map((param, index) => {
      const label = Object.entries(labelToKeyMap).find(([_, key]) => key === (param as any))?.[0];
      
      return (
        <CheckBox
          key={index}
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue}
          isChecked={templateData?.dataParameter?.includes(param as unknown as DataObj)}
          onChange={() => {
            const isChecked = templateData?.dataParameter?.includes(param as unknown as DataObj);
            const updatedParams = isChecked
              ? templateData && templateData.dataParameter?.filter(id => id !== (param as unknown as DataObj))
              : [...(templateData?.dataParameter || []), param as unknown as DataObj];
              onTemplateDataChange({ ...templateData, templateId: templateData?.templateId || 0, dataParameter: updatedParams });
          }}
        />
      );
    });
  }, [onTemplateDataChange, templateData, t]);
  
  return(
    <div style={{maxHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{width: "fit-content", display: "grid", gridTemplateColumns: mobileXs ? "1fr 1fr" : "1fr 1fr 1fr", gridTemplateRows: mobileXs ? "1fr 1fr" : "", columnGap: mobileXs ? "50px" : "100px", rowGap: "10px"}}>
        {checkboxes}
      </div>
    </div>
  )
}